import React from 'react';

import Modal from 'modal-react-native-web';
import moment from 'moment';
import {
  Alert,
  BackHandler,
  FlatList,
  Image,
  ScrollView,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import {Calendar, LocaleConfig} from 'react-native-calendars';
import {Card, Icon} from 'react-native-elements';

LocaleConfig.locales['pt-BR'] = {
  monthNames: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  monthNamesShort: [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
  ],
  dayNames: [
    'Domingo',
    'Segunda',
    'Terça',
    'Quarta',
    'Quinta',
    'Sexta',
    'Sábado',
  ],
  dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  today: 'Hoje',
};
LocaleConfig.defaultLocale = 'pt-BR';

import {createAppContainer, NavigationActions} from 'react-navigation';
import {createStackNavigator} from 'react-navigation-stack';
import {version} from '../package.json';
import {
  churrasqueiras,
  images_areia,
  images_churrasqueiras,
  images_padel,
  images_pickleball,
  quadras_areia,
  quadras_padel,
  quadras_pickleball,
} from './constants.js';

import {styles} from './Styles';

import firebase from 'firebase';
import db from './firebase_app';
// import * as ProgressBar from 'react-native-progress';

const colors = ['#dc812e'];
var shajs = require('sha.js');

//console.log('moment')
//console.log(moment().toDate())

const logo_list = [
  require('../img/construction.jpg'),
  require('../img/construction.jpg'),
  // require('./img/stjoes.jpg')
  require('../img/eleven_horizontal_white.jpeg'),
  require('../img/eleven_horizontal_white.jpeg'),
  require('../img/quadras.jpeg'),
];
const location_list = [
  require('../img/areia.jpeg'),
  require('../img/padel.jpeg'),
  // require('../img/pickleball.png'),
  require('../img/pickleball2.jpg'),
  require('../img/churrasqueira.jpeg'),
];
const location_n = {
  areia: 11,
  padel: 5,
  pickleball: 1,
  churrasqueira: 5,
};

class CalendarScreen extends React.Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);

    var n_offset = 50;
    this.state = {
      first: null,
      first_query_done: false,
    };
    var user = firebase.auth().currentUser.uid;
    const tutorial_ref = db
      .ref('/first/' + user)
      .once('value')
      .then(snapshot => {
        //console.log('FIRST')
        //console.log(snapshot.val())
        this.setState({
          first: snapshot.val(),
          first_query_done: true,
        });
      });
    var params = this.props.navigation.state.params;
    // console.log('state')
    // console.log(this.props.navigation.state)
    // console.log('params')
    // console.log(params);
    if (params && 'tutorial' in params) {
      navigate('Identity', {first: true});
    } else {
      // console.log('Version...')
      // console.log(version)
      db.ref('/version')
        .once('value')
        .then(snapshot => {
          const server_version = snapshot.val();
          if (server_version != version) {
            Alert.alert(
              'Sua versão está desatualizada.',
              'Favor atualize seu app pela Play Store (Android) ou App Store (iOS).',
              [{text: 'OK', onPress: this.logOut}],
            );
          }
        });
    }
  }

  static navigationOptions = {
    headerMode: 'none',
    header: null,
  };

  logOut() {
    firebase
      .auth()
      .signOut()
      .then(() => {
        // console.log('here...')
        // console.log(this.props.navigation)
        // console.log('navigation...')
        // this.props.navigation.dispatch(
        //   {
        //       type: 'Navigation/BACK',
        //
        //   }
        // );
        // this.props.navigation.reset([NavigationActions.navigate({
        //     routeName: 'Login'
        //   })], 0);
        this.props.navigation.goBack(null);
      })
      .catch(function(error) {
        // An error happened.
      });
  }

  render() {
    //console.log('\n\nFIRST SCREEN\n\n')
    // console.log(today_done)
    const {navigate} = this.props.navigation;
    var first = this.state.first;
    var first_query_done = this.state.first_query_done;
    // console.log('First_query_done')
    // console.log(first_query_done)

    var max_date = new Date(); // today!
    var x = 7; // go back 5 days!
    max_date.setDate(max_date.getDate() + x);
    var user = firebase.auth().currentUser;

    if (first_query_done) {
      if (first === null) {
        return navigate('Identity', {first: true});
      }

      return (
        <View
          style={{
            flex: 1,
            backgroundColor: '#f7f7f7',
            flexDirection: 'column',
          }}>
          <View
            style={{
              flex: 0.05,
              flexDirection: 'row',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              marginTop: 30,
              marginRight: 20,
            }}>
            <TouchableOpacity onPress={this.logOut}>
              <Icon name="exchange" size={30} type="font-awesome" />
              <Text style={{textAlign: 'center'}}>Sair</Text>
            </TouchableOpacity>
          </View>

          <View
            style={{
              flex: 1,
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#f7f7f7',
            }}>
            <Image source={logo_list[2]} style={styles.logoEleven} />
            <Calendar
              // Minimum date that can be selected, dates before minDate will be grayed out. Default = undefined
              minDate={new Date()}
              // Maximum date that can be selected, dates after maxDate will be grayed out. Default = undefined
              maxDate={max_date}
              // Handler which gets executed on day press. Default = undefined
              onDayPress={day => {
                dayPressed(navigate, day);
              }}
              // Handler which gets executed on day long press. Default = undefined
              onDayLongPress={day => {
                console.log('selected day', day);
              }}
              // Handler which gets executed when press arrow icon left. It receive a callback can go back month
              onPressArrowLeft={substractMonth => substractMonth()}
              // Handler which gets executed when press arrow icon left. It receive a callback can go next month
              onPressArrowRight={addMonth => addMonth()}
              // Mark days
              markingType={'custom'}
              renderArrow={direction => {
                const name = 'arrow-' + direction;
                return <Icon type="font-awesome" name={name} size={20} />;
              }}
              theme={{
                arrowColor: colors[0],
                todayTextColor: colors[0],
              }}
              style={{width: '90%'}}
            />
            <TouchableOpacity
              style={{marginTop: 20}}
              onPress={() =>
                this.props.navigation.navigate('Identity', {first: false})
              }>
              <Text style={{color: 'orange'}}>
                Atualize seus documentos clicando aqui
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      );
    } else if (!first_query_done) {
      return (
        <View
          style={{
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f7f7f7',
          }}>
          <Image source={logo_list[2]} style={styles.logoEleven} />
        </View>
      );
    } else if (first_query_done && first === null) {
      return navigate('Identity', {first: true});
    }
  }
}

function dayPressed(navigate, day) {
  console.log('day', day);
  navigate('Location', {day: day});
}

class ScheduleScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dates: null,
      query_done: false,
    };
    const {navigate} = this.props.navigation;

    var params = this.props.navigation.state.params;
    var user = firebase.auth().currentUser.uid;
    const tutorial_ref = db
      .ref('/schedule/' + params['location'] + '/' + params['day'].dateString)
      .once('value')
      .then(snapshot => {
        //console.log("Schedule")
        console.log('Schedule', snapshot.val());
        this.setState({
          dates: snapshot.val(),
          query_done: true,
        });
      });
  }

  static navigationOptions = {
    headerMode: 'none',
    header: null,
  };

  render() {
    var query_done = this.state.query_done;
    var dates = this.state.dates;
    var params = this.props.navigation.state.params;
    const {navigate} = this.props.navigation;

    var cards = [
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
    ];
    var cards_churrasqueira = ['Meio-dia', 'Noite'];
    console.log('dates', dates);
    var disabled = [];
    if (dates != null) {
      var keys = Object.keys(dates);
      for (const key of keys) {
        // var index = cards.indexOf(key);
        // console.log(key, index)
        console.log('dates[key]', key);
        // console.log(key)
        console.log('object', Object.keys(dates[key]).length);
        if (Object.keys(dates[key]).length === location_n[params['location']]) {
          if (params['location'] === 'churrasqueira') {
            disabled.push(key);
          } else {
            disabled.push(parseInt(key));
          }
          // cards = cards.filter(function(e) { return e !== parseInt(key) })
        }
      }
    }
    // console.log('Disabled')
    // console.log(disabled)
    if (query_done && params['location'] === 'churrasqueira') {
      return (
        <View>
          <Progress n="3" active="1" />
          <FlatList
            data={cards_churrasqueira}
            renderItem={({item}) => (
              <View style={{flex: 1, flexDirection: 'column', margin: 1}}>
                {[0].map((prop, key) => {
                  if (!disabled.includes(item)) {
                    return (
                      <TouchableOpacity
                        key={item}
                        onPress={() =>
                          selectedDay(
                            navigate,
                            params['location'],
                            params['day'],
                            item,
                          )
                        }>
                        <Card
                          containerStyle={{alignItems: 'center'}}
                          key={item}>
                          <Text>{item}</Text>
                        </Card>
                      </TouchableOpacity>
                    );
                  } else {
                    return (
                      <TouchableOpacity
                        style={{opacity: 0.3}}
                        disabled={true}
                        key={item}
                        onPress={() =>
                          selectedDay(
                            navigate,
                            params['location'],
                            params['day'],
                            item,
                          )
                        }>
                        <Card
                          containerStyle={{alignItems: 'center'}}
                          key={item}>
                          <Text>Lotado</Text>
                        </Card>
                      </TouchableOpacity>
                    );
                  }
                })}
              </View>
            )}
            //Setting the number of column
            numColumns={3}
            keyExtractor={(item, index) => index.toString()}
          />
        </View>
      );
    } else if (query_done) {
      console.log('query_done', query_done);
      return (
        <View>
          <Progress n="3" active="1" />
          <FlatList
            data={cards}
            renderItem={({item}) => (
              <View style={{flex: 1, flexDirection: 'column', margin: 1}}>
                {[0].map((prop, key) => {
                  if (!disabled.includes(item)) {
                    return (
                      <TouchableOpacity
                        key={item}
                        onPress={() =>
                          selectedDay(
                            navigate,
                            params['location'],
                            params['day'],
                            item,
                          )
                        }>
                        <Card
                          containerStyle={{alignItems: 'center'}}
                          key={item}>
                          <Text>{item}h</Text>
                        </Card>
                      </TouchableOpacity>
                    );
                  } else {
                    return (
                      <TouchableOpacity
                        style={{opacity: 0.3}}
                        disabled={true}
                        key={item}
                        onPress={() =>
                          selectedDay(
                            navigate,
                            params['location'],
                            params['day'],
                            item,
                          )
                        }>
                        <Card
                          containerStyle={{alignItems: 'center'}}
                          key={item}>
                          <Text>Lotado</Text>
                        </Card>
                      </TouchableOpacity>
                    );
                  }
                })}
              </View>
            )}
            //Setting the number of column
            numColumns={3}
            keyExtractor={(item, index) => index.toString()}
          />
        </View>
      );
    } else {
      return <View />;
    }
  }
}

class Progress extends React.Component {
  constructor(props) {
    super(props);
    console.log('props', props);
    this.state = {
      stages: new Array(Number.parseInt(props.n)).fill(0),
      active: Number.parseInt(props.active),
      desc: [
        'Escolha uma modalidade',
        'Escolha um horário',
        'Escolha um espaço',
      ],
    };
  }
  render() {
    const {stages} = this.state;
    const {active} = this.state;
    const {desc} = this.state;
    console.log('stages', stages);
    return (
      <View
        style={{
          height: 40,
          marginBottom: 20,
          marginTop: 15,
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <Text style={{fontSize: 18}}>{desc[active]}</Text>
        <View
          style={{
            height: 40,
            marginTop: 15,
            flexDirection: 'row',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          {stages.map((prop, key) => {
            if (key === active) {
              if (key < stages.length - 1) {
                return (
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    <View
                      style={{
                        height: 20,
                        width: 20,
                        borderRadius: 10,
                        backgroundColor: colors[0],
                      }}
                    />
                    <View
                      style={{
                        height: 1,
                        width: 40,
                        borderWidth: 1,
                        borderColor: colors[0],
                      }}
                    />
                  </View>
                );
              } else {
                return (
                  <View
                    style={{
                      height: 20,
                      width: 20,
                      borderRadius: 10,
                      backgroundColor: colors[0],
                    }}
                  />
                );
              }
            } else {
              if (key < stages.length - 1) {
                return (
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    <View
                      style={{
                        height: 20,
                        width: 20,
                        borderRadius: 10,
                        borderWidth: 1,
                        borderColor: colors[0],
                      }}
                    />
                    <View
                      style={{
                        height: 1,
                        width: 40,
                        borderWidth: 1,
                        borderColor: colors[0],
                      }}
                    />
                  </View>
                );
              } else {
                return (
                  <View
                    style={{
                      height: 20,
                      width: 20,
                      borderRadius: 10,
                      borderWidth: 1,
                      borderColor: colors[0],
                    }}
                  />
                );
              }
            }
          })}
        </View>
      </View>
    );
  }
}

class LocationScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dates: null,
      query_done: false,
    };
    const {navigate} = this.props.navigation;

    var params = this.props.navigation.state.params;
    var user = firebase.auth().currentUser.uid;
  }

  static navigationOptions = {
    headerMode: 'none',
    header: null,
  };

  render() {
    var query_done = this.state.query_done;
    var dates = this.state.dates;
    var params = this.props.navigation.state.params;
    const {navigate} = this.props.navigation;

    return (
      <ScrollView>
        <Progress n="3" active="0" />
        <TouchableOpacity
          key="areia"
          onPress={() => selectedLocation(navigate, 'areia', params['day'])}>
          <Card
            title="Areia"
            image={location_list[0]}
            pointerEvents="none"
            key="areia-card"
          />
        </TouchableOpacity>
        <TouchableOpacity
          key="padel"
          onPress={() => selectedLocation(navigate, 'padel', params['day'])}>
          <Card
            title="Padel"
            image={location_list[1]}
            pointerEvents="none"
            key="padel-card"
          />
        </TouchableOpacity>
        <TouchableOpacity
          key="pickleball"
          onPress={() =>
            selectedLocation(navigate, 'pickleball', params['day'])
          }>
          <Card
            title="Pickleball"
            image={location_list[2]}
            pointerEvents="none"
            key="pickleball-card"
          />
        </TouchableOpacity>
        {/* <TouchableOpacity key="churrasqueira" onPress={() => selectedLocation(navigate, "churrasqueira", params["day"])}>
           <Card title="Churrasqueira" image={location_list[2]} pointerEvents="none" key="churrasqueira-card">
           </Card>
         </TouchableOpacity> */}
      </ScrollView>
    );
  }
}

class Location2Screen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query_done: false,
      not_available: null,
      modalVisible: false,
      pos_x: 0,
      pos_y: 0,
    };
    const {navigate} = this.props.navigation;

    var params = this.props.navigation.state.params;
    var user = firebase.auth().currentUser.uid;
    var query =
      '/schedule/' +
      params['location'] +
      '/' +
      params['day'].dateString +
      '/' +
      params['hour'].toString();
    console.log('QUERY', query);
    const locations_ref = db
      .ref(query)
      .once('value')
      .then(snapshot => {
        var snap = snapshot.val();
        console.log('snap', snap);
        if (snap === null) {
          this.setState({
            query_done: true,
            not_available: [],
          });
        } else {
          this.setState({
            query_done: true,
            not_available: Object.keys(snap),
          });
        }
      });
  }

  static navigationOptions = {
    headerMode: 'none',
    header: null,
  };

  setModalVisible(visible, pos_x, pos_y) {
    this.setState({modalVisible: visible, pos_x, pos_y});
  }
  render() {
    var query_done = this.state.query_done;
    var dates = this.state.dates;
    var {not_available} = this.state;
    var {pos_x, pos_y} = this.state;
    var params = this.props.navigation.state.params;
    var {location} = params;
    var {day} = params;
    var {hour} = params;
    const {navigate} = this.props.navigation;

    console.log('this.state', this.state);
    if (!query_done) {
      return <ScrollView />;
    }
    if (location === 'areia') {
      return (
        <ScrollView>
          <Modal
            animationType="fade"
            transparent={false}
            visible={this.state.modalVisible}
            onRequestClose={() => {
              this.setModalVisible(false, 0, 0);
            }}>
            <View style={{marginTop: 20, flex: 1, alignItems: 'center'}}>
              <View>
                <View
                  style={{
                    marginBottom: 20,
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                  }}>
                  <Icon
                    type="font-awesome"
                    name="close"
                    size={30}
                    onPress={() => this.setModalVisible(false, 0, 0)}
                  />
                </View>
                <View style={{position: 'relative', flex: 1, width: 335}}>
                  <Image
                    source={logo_list[4]}
                    style={{height: 300, width: 'auto'}}
                    resizeMode="center"
                  />
                  <Icon
                    size={40}
                    color="red"
                    name="arrow-downward"
                    containerStyle={{
                      position: 'absolute',
                      top: pos_y,
                      right: pos_x,
                    }}
                  />
                </View>
              </View>
            </View>
          </Modal>
          <Progress n="3" active="2" />
          {quadras_areia.map((prop, key) => {
            const positions = [
              [65, 50],
              [118, 50],
              [167, 50],
              [215, 50],
              [267, 50],
            ];
            if (!not_available.includes('space-' + key.toString())) {
              return (
                <View>
                  <TouchableOpacity
                    key={'opacity-' + key}
                    onPress={() =>
                      finalSelection(navigate, 'areia', day, hour, key)
                    }>
                    <Card
                      title={quadras_areia[key]}
                      pointerEvents="none"
                      key={key}
                      onPress={() =>
                        finalSelection(navigate, 'areia', day, hour, key)
                      }>
                      <Image
                        source={images_areia[key]}
                        style={styles.imgAgenda}
                        resizeMode="contain"
                      />
                    </Card>
                  </TouchableOpacity>
                </View>
              );
            } else {
              return (
                <View>
                  <TouchableOpacity
                    style={{opacity: 0.3}}
                    disabled={true}
                    key={'opacity-' + key}
                    onPress={() =>
                      finalSelection(navigate, 'areia', day, hour, key)
                    }>
                    <Card
                      title={'Reservada'}
                      pointerEvents="none"
                      key={key}
                      style={{opacity: 0.3}}
                      disabled={true}>
                      <Image
                        source={images_areia[key]}
                        style={styles.imgAgenda}
                        resizeMode="contain"
                      />
                    </Card>
                  </TouchableOpacity>
                </View>
              );
            }
          })}
        </ScrollView>
      );
    } else if (location === 'padel') {
      return (
        <ScrollView>
          <Modal
            animationType="fade"
            transparent={false}
            visible={this.state.modalVisible}
            onRequestClose={() => {
              this.setModalVisible(false, 0, 0);
            }}>
            <View style={{marginTop: 20, flex: 1, alignItems: 'center'}}>
              <View>
                <View
                  style={{
                    marginBottom: 20,
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                  }}>
                  <Icon
                    type="font-awesome"
                    name="close"
                    size={30}
                    onPress={() => this.setModalVisible(false, 0, 0)}
                  />
                </View>
                <View style={{position: 'relative', flex: 1, width: 335}}>
                  <Image
                    source={logo_list[4]}
                    style={{height: 300, width: 'auto'}}
                    resizeMode="center"
                  />
                  <Icon
                    size={40}
                    color="red"
                    name="arrow-downward"
                    containerStyle={{
                      position: 'absolute',
                      top: pos_y,
                      right: pos_x,
                    }}
                  />
                </View>
              </View>
            </View>
          </Modal>
          <Progress n="3" active="2" />
          {quadras_padel.map((prop, key) => {
            const positions = [[60, 175], [122, 175], [186, 175], [253, 175]];
            if (!not_available.includes('space-' + key.toString())) {
              return (
                <View>
                  <TouchableOpacity
                    key={'opacity-' + key}
                    onPress={() =>
                      finalSelection(navigate, 'padel', day, hour, key)
                    }>
                    <Card
                      title={quadras_padel[key]}
                      pointerEvents="none"
                      key={key}>
                      <Image
                        source={images_padel[key]}
                        style={styles.imgAgenda}
                        resizeMode="contain"
                      />
                    </Card>
                  </TouchableOpacity>
                </View>
              );
            } else {
              return (
                <View>
                  <TouchableOpacity
                    style={{opacity: 0.3}}
                    disabled={true}
                    key={'opacity-' + key}
                    onPress={() =>
                      finalSelection(navigate, 'padel', day, hour, key)
                    }>
                    <Card title={'Reservada'} pointerEvents="none" key={key}>
                      <Image
                        source={images_padel[key]}
                        style={styles.imgAgenda}
                        resizeMode="contain"
                      />
                    </Card>
                  </TouchableOpacity>
                  <Icon
                    name="info-circle"
                    type="font-awesome"
                    size={30}
                    containerStyle={{position: 'absolute', top: 25, right: 25}}
                    onPress={() =>
                      this.setModalVisible(
                        true,
                        positions[key][0],
                        positions[key][1],
                      )
                    }
                  />
                </View>
              );
            }
          })}
        </ScrollView>
      );
    } else if (location === 'pickleball') {
      return (
        <ScrollView>
          <Modal
            animationType="fade"
            transparent={false}
            visible={this.state.modalVisible}
            onRequestClose={() => {
              this.setModalVisible(false, 0, 0);
            }}>
            <View style={{marginTop: 20, flex: 1, alignItems: 'center'}}>
              <View>
                <View
                  style={{
                    marginBottom: 20,
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                  }}>
                  <Icon
                    type="font-awesome"
                    name="close"
                    size={30}
                    onPress={() => this.setModalVisible(false, 0, 0)}
                  />
                </View>
                <View style={{position: 'relative', flex: 1, width: 335}}>
                  <Image
                    source={logo_list[4]}
                    style={{height: 300, width: 'auto'}}
                    resizeMode="center"
                  />
                  <Icon
                    size={40}
                    color="red"
                    name="arrow-downward"
                    containerStyle={{
                      position: 'absolute',
                      top: pos_y,
                      right: pos_x,
                    }}
                  />
                </View>
              </View>
            </View>
          </Modal>
          <Progress n="3" active="2" />
          {quadras_pickleball.map((prop, key) => {
            const positions = [[60, 175], [122, 175], [186, 175], [253, 175]];
            if (!not_available.includes('space-' + key.toString())) {
              return (
                <View>
                  <TouchableOpacity
                    key={'opacity-' + key}
                    onPress={() =>
                      finalSelection(navigate, 'pickleball', day, hour, key)
                    }>
                    <Card
                      title={quadras_pickleball[key]}
                      pointerEvents="none"
                      key={key}>
                      <Image
                        source={images_pickleball[key]}
                        style={styles.imgAgenda}
                        resizeMode="contain"
                      />
                    </Card>
                  </TouchableOpacity>
                </View>
              );
            } else {
              return (
                <View>
                  <TouchableOpacity
                    style={{opacity: 0.3}}
                    disabled={true}
                    key={'opacity-' + key}
                    onPress={() =>
                      finalSelection(navigate, 'pickleball', day, hour, key)
                    }>
                    <Card title={'Reservada'} pointerEvents="none" key={key}>
                      <Image
                        source={images_pickleball[key]}
                        style={styles.imgAgenda}
                        resizeMode="contain"
                      />
                    </Card>
                  </TouchableOpacity>
                  <Icon
                    name="info-circle"
                    type="font-awesome"
                    size={30}
                    containerStyle={{position: 'absolute', top: 25, right: 25}}
                    onPress={() =>
                      this.setModalVisible(
                        true,
                        positions[key][0],
                        positions[key][1],
                      )
                    }
                  />
                </View>
              );
            }
          })}
        </ScrollView>
      );
    } else if (location === 'churrasqueira') {
      return (
        <ScrollView>
          <Modal
            animationType="fade"
            transparent={false}
            visible={this.state.modalVisible}
            onRequestClose={() => {
              this.setModalVisible(false, 0, 0);
            }}>
            <View style={{marginTop: 20, flex: 1, alignItems: 'center'}}>
              <View>
                <View
                  style={{
                    marginBottom: 20,
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                  }}>
                  <Icon
                    type="font-awesome"
                    name="close"
                    size={30}
                    onPress={() => this.setModalVisible(false, 0, 0)}
                  />
                </View>
                <View style={{position: 'relative', flex: 1, width: 335}}>
                  <Image
                    source={logo_list[4]}
                    style={{height: 300, width: 'auto'}}
                    resizeMode="center"
                  />
                  <Icon
                    size={40}
                    color="red"
                    name="arrow-downward"
                    containerStyle={{
                      position: 'absolute',
                      top: pos_y,
                      right: pos_x,
                    }}
                  />
                </View>
              </View>
            </View>
          </Modal>
          <Progress n="3" active="2" />
          {churrasqueiras.map((prop, key) => {
            const positions = [
              [15, 245],
              [135, 245],
              [175, 245],
              [118, -20],
              [55, -20],
            ];
            if (!not_available.includes('space-' + key.toString())) {
              return (
                <View>
                  <TouchableOpacity
                    key={'opacity-' + key}
                    onPress={() =>
                      finalSelection(navigate, 'churrasqueira', day, hour, key)
                    }>
                    <Card
                      title={churrasqueiras[key]}
                      image={images_churrasqueiras[key]}
                      pointerEvents="none"
                      key={key}
                    />
                  </TouchableOpacity>
                  <Icon
                    name="info-circle"
                    type="font-awesome"
                    size={30}
                    containerStyle={{position: 'absolute', top: 25, right: 25}}
                    onPress={() =>
                      this.setModalVisible(
                        true,
                        positions[key][0],
                        positions[key][1],
                      )
                    }
                  />
                </View>
              );
            } else {
              return (
                <View>
                  <TouchableOpacity
                    style={{opacity: 0.3}}
                    disabled={true}
                    key={'opacity-' + key}
                    onPress={() =>
                      finalSelection(navigate, 'churrasqueira', day, hour, key)
                    }>
                    <Card
                      title={'Reservada'}
                      image={images_churrasqueiras[key]}
                      pointerEvents="none"
                      key={key}
                    />
                  </TouchableOpacity>
                  <Icon
                    name="info-circle"
                    type="font-awesome"
                    size={30}
                    containerStyle={{position: 'absolute', top: 25, right: 25}}
                    onPress={() =>
                      this.setModalVisible(
                        true,
                        positions[key][0],
                        positions[key][1],
                      )
                    }
                  />
                </View>
              );
            }
          })}
        </ScrollView>
      );
    }
  }
}

function selectedLocation(navigate, location, day) {
  navigate('Schedule', {location: location, day: day});
}

function selectedDay(navigate, location, day, hour) {
  navigate('Location2', {location: location, day: day, hour: hour});
}

const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];
function formatDate(date, hour) {
  var splitted = date.split('-');
  var year = splitted[0];
  var month = splitted[1];
  var day = splitted[2];

  if (hour === 'Meio-dia' || hour === 'Noite') {
    return (
      day + ' de ' + MONTHS[parseInt(month - 1)] + ' de ' + year + '\n' + hour
    );
  }
  return (
    day +
    ' de ' +
    MONTHS[parseInt(month - 1)] +
    ' de ' +
    year +
    '\nÀs ' +
    hour +
    'h'
  );
}

function finalSelection(navigate, location, day, hour, location_2) {
  console.log('hour', hour);
  var alert_string = formatDate(day.dateString, hour);
  const res = confirm(alert_string);
  if (res) {
    console.log('res', res);
    scheduleAndNavigate(navigate, location, day, hour, location_2);
  } else {
    console.log('cancel pressed');
  }
}

function scheduleAndNavigate(navigate, location, day, hour, location_2) {
  let gravou = false;
  var user = firebase.auth().currentUser.uid;
  db.ref('/profile/' + user)
    .once('value')
    .then(snapshot => {
      var profile = snapshot.val();

      db.ref(
        '/schedule/' +
          location +
          '/' +
          day.dateString +
          '/' +
          hour.toString() +
          '/space-' +
          location_2.toString(),
      )
        .once('value')
        .then(snapshot => {
          if (!snapshot.val()) {
            if (
              location != 'churrasqueira' &&
              profile['professor'] != null &&
              profile['professor']
            ) {
              console.log('professor');
              const res_prof = confirm(
                'Deseja marcar esse jogo como professor?\nOK para marcar como professor\nCancelar para marcar como jogador.',
              );

              if (res_prof) {
                db.ref(
                  '/schedule/' +
                    location +
                    '/' +
                    day.dateString +
                    '/' +
                    hour.toString() +
                    '/space-' +
                    location_2.toString(),
                ).set({
                  identity_professor: profile['identity'],
                  name: profile['name'] + ' - como Professor',
                  identity: 'pending',
                  date: moment()
                    .toDate()
                    .toISOString(),
                });
                const push_ref = db.ref('/professor/' + user).push();
                push_ref.set(
                  '\\schedule\\' +
                    location +
                    '\\' +
                    day.dateString +
                    '\\' +
                    hour.toString() +
                    '\\space-' +
                    location_2.toString(),
                );
                return;
              }
            }

            console.log('not professor');
            db.ref(
              '/schedule/' +
                location +
                '/' +
                day.dateString +
                '/' +
                hour.toString() +
                '/space-' +
                location_2.toString(),
            )
              .set({
                identity: profile['identity'],
                name: profile['name'],
                date: moment()
                  .toDate()
                  .toISOString(),
              })
              .then(
                logMovimentacao(
                  'new',
                  day.dateString,
                  location,
                  location_2 + 1,
                  hour,
                  profile['name'],
                  dataFormatada(),
                  profile['name'],
                  'aplicativo',
                ),
              );

            console.log('gravou no banco');
          } else {
            Alert.alert(
              'Parece que alguém acabou de marcar este mesmo horário.',
              'Tente novamente.',
              [{text: 'OK', onPress: () => navigate('First')}],
            );
          }
        });
    });

  alert(
    'Agendamento realizado. Se sua reserva não aparecer na sua lista de agendados, favor reiniciar o app e verificar novamente.\nVocê pode desmarcar seu horário até 12 horas antes ou nos próximos 15 minutos.',
  );
  navigate('First');
}

/* Start Função log*/
function dataFormatada(diaQuadra) {
  if (diaQuadra) {
    let data = new Date(diaQuadra),
      dia = data.getDate().toString(),
      diaF = dia.length == 1 ? '0' + dia : dia,
      mes = (data.getMonth() + 1).toString(),
      mesF = mes.length == 1 ? '0' + mes : mes,
      anoF = data.getFullYear();
    let completeData = `${diaF}-${mesF}-${anoF}`;
    return completeData;
  } else {
    let data = new Date(),
      dia = data.getDate().toString(),
      diaF = dia.length == 1 ? '0' + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = mes.length == 1 ? '0' + mes : mes,
      anoF = data.getFullYear();
    let completeData = `${diaF}-${mesF}-${anoF}`;
    return completeData;
  }
}

function horaAtualFormatada() {
  let data = new Date(),
    hora = data.getHours().toString(),
    horaF = hora.length == 1 ? '0' + hora : hora,
    minuto = data.getMinutes().toString(),
    minutoF = minuto.length == 1 ? '0' + minuto : minuto,
    segundo = data.getSeconds().toString(),
    segundoF = segundo.length == 1 ? '0' + segundo : segundo;

  let completeHour = `${horaF}-${minutoF}-${segundoF}`;
  return completeHour;
}

function testeThen() {
  console.log('then funciona');
}
function logMovimentacao(
  type,
  dataMarcada,
  modalityb,
  spaceb,
  hourb,
  name,
  dataN,
  registered_by,
  origin,
) {
  const dateString = dataMarcada.split('-');
  const dataMarcadaN = `${dateString[2]}-${dateString[1]}-${dateString[0]}`;

  const horas = horaAtualFormatada();
  db.ref(
    `/log/${modalityb}/${spaceb}/${hourb}/${dataMarcadaN}/${type}/${dataN}/${horas}`,
  )
    .once('value')
    .then(snapshot2 => {
      console.log('entrei aqui');
      console.log('snapshot2', snapshot2);
      if (!snapshot2.val()) {
        db.ref(
          `/log/${modalityb}/${spaceb}/${hourb}/${dataMarcadaN}/${type}/${dataN}/${horas}`,
        ).set({
          // type: `${type}`,
          action: `${registered_by} ${
            type == 'new'
              ? `marcou para o dia ${dataMarcadaN} a quadra ${spaceb} de ${modalityb} no horário ${hourb} para ${name}, no dia ${dataN} as ${horas} ${
                  origin == 'interno'
                    ? 'pelo sistema interno'
                    : 'pelo aplicativo'
                }`
              : `desmarcou a a quadra ${spaceb} de ${modalityb} do dia ${dataMarcadaN} as ${hourb} para ${name}, no dia ${dataN} as ${horas} ${
                  origin == 'interno'
                    ? 'pelo sistema interno'
                    : 'pelo aplicativo'
                }`
          }`,
        });
      } else {
        alert(
          'Alguém acabou de marcar neste mesmo horário. Atualize sua visualização.',
        );
      }
    });
}
/* End função log */

class IdentityScreen extends React.Component {
  constructor(props) {
    super(props);
    const current_params = this.props.navigation.state.params;
    this.state = {
      identity: null,
      first: current_params['first'],
    };
    this.handleBackButton = this.handleBackButton.bind(this);
  }

  componentDidMount() {
    BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);
  }

  componentWillUnmount() {
    BackHandler.removeEventListener('hardwareBackPress', this.handleBackButton);
  }

  handleBackButton() {
    if (this.state.first) {
      return true;
    }
    // else {
    //   this.props.navigation.navigate('First');
    // }
  }

  static navigationOptions = {
    headerMode: 'none',
    header: null,
  };

  render() {
    const {navigate} = this.props.navigation;

    return (
      <View
        style={{
          flex: 1,
          marginRight: '10%',
          marginLeft: '10%',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
        <Text style={styles.textStyle}>
          Favor, adicionar um documento de identidade:
        </Text>
        <Text style={{fontSize: 14, color: 'blue'}}>
          Nós codificamos o seu documento para maior segurança.
        </Text>
        <TextInput
          placeholder="Identidade"
          underlineColorAndroid="transparent"
          style={styles.textInputStyle}
          keyboardType={'numeric'}
          onChangeText={identity => this.setState({identity})}
        />
        <TouchableOpacity
          onPress={() => navigate_tutorial(navigate, this.state, 'Name')}
          style={styles.tutorialNextButton}>
          <Text style={{color: 'white', size: 20}}>{'Próximo >>'} </Text>
        </TouchableOpacity>
      </View>
    );
  }
}

class NameScreen extends React.Component {
  constructor(props) {
    super(props);

    var current_params = this.props.navigation.state.params;
    this.state = {
      identity: current_params['identity'],
      name: null,
    };
  }

  static navigationOptions = {
    headerMode: 'none',
    header: null,
  };

  render() {
    const {navigate} = this.props.navigation;

    return (
      <View
        style={{
          flex: 1,
          marginRight: '10%',
          marginLeft: '10%',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
        <Text style={styles.textStyle}>Favor, digite seu nome completo:</Text>
        <TextInput
          placeholder="Nome"
          underlineColorAndroid="transparent"
          style={styles.textInputStyle}
          onChangeText={name => this.setState({name})}
        />
        <TouchableOpacity
          onPress={() => navigate_tutorial(navigate, this.state, 'Phone')}
          style={styles.tutorialNextButton}>
          <Text style={{color: 'white', size: 20}}>{'Próximo >>'} </Text>
        </TouchableOpacity>
      </View>
    );
  }
}

class PhoneScreen extends React.Component {
  constructor(props) {
    super(props);

    var current_params = this.props.navigation.state.params;
    this.state = {
      identity: current_params['identity'],
      name: current_params['name'],
      phone: null,
    };
  }

  static navigationOptions = {
    headerMode: 'none',
    header: null,
  };

  render() {
    const {navigate} = this.props.navigation;

    return (
      <View
        style={{
          flex: 1,
          marginRight: '10%',
          marginLeft: '10%',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
        <Text style={styles.textStyle}>Favor, digite um telefone válido:</Text>
        <TextInput
          placeholder="Telefone"
          underlineColorAndroid="transparent"
          style={styles.textInputStyle}
          keyboardType={'numeric'}
          onChangeText={phone => this.setState({phone})}
        />
        <TouchableOpacity
          onPress={() => navigate_tutorial(navigate, this.state, 'Save')}
          style={styles.tutorialNextButton}>
          <Text style={{color: 'white', size: 20}}>{'Próximo >>'} </Text>
        </TouchableOpacity>
      </View>
    );
  }
}

function navigate_tutorial(navigate, state, next_screen) {
  var identity = parseFloat(state['identity']);
  console.log(identity);
  if (identity != null && next_screen === 'Name') {
    if (Number.isInteger(identity)) {
      navigate(next_screen, state);
    } else {
      Alert.alert(
        'Inválido',
        'Preencha um número de identidade válido.',
        [{text: 'OK', onPress: () => console.log('OK Pressed')}],
        {cancelable: false},
      );
    }
  } else if (state['name'] != null && next_screen === 'Phone') {
    if (state['name'] !== '') {
      navigate(next_screen, state);
    } else {
      Alert.alert(
        'Inválido',
        'Preencha um nome válido.',
        [{text: 'OK', onPress: () => console.log('OK Pressed')}],
        {cancelable: false},
      );
    }
  } else if (state['phone'] != null && next_screen === 'Save') {
    if (state['phone'] !== '') {
      navigate(next_screen, state);
    } else {
      Alert.alert(
        'Inválido',
        'Preencha um telefone válido.',
        [{text: 'OK', onPress: () => console.log('OK Pressed')}],
        {cancelable: false},
      );
    }
  } else {
    Alert.alert(
      'Incompleto',
      'Você precisa preencher as informações para prosseguir.',
      [{text: 'OK', onPress: () => console.log('OK Pressed')}],
      {cancelable: false},
    );
  }
}

class SaveScreen extends React.Component {
  constructor(props) {
    super(props);
  }

  static navigationOptions = {
    headerMode: 'none',
    header: null,
  };

  render() {
    var user = firebase.auth().currentUser.uid;
    // console.log(this.props.navigation.state.params)
    var current_params = this.props.navigation.state.params;
    db.ref('/first/' + user).set(true);
    console.log('Identity');
    console.log(current_params['identity']);
    // console.log(sha256(current_params["identity"]))
    const hash = shajs('sha256')
      .update(current_params['identity'])
      .digest('hex');
    current_params['identity'] = hash;
    db.ref('/profile/' + user).set(current_params);
    // .then( hash => {
    //   current_params["identity"] = hash
    //   db.ref('/profile/' + user).set(
    //     current_params
    //   );
    // })

    return this.props.navigation.reset(
      [
        NavigationActions.navigate({
          routeName: 'First',
        }),
      ],
      0,
    );
  }
}

const AgendaNavigator = createStackNavigator({
  First: {screen: CalendarScreen},
  Identity: {screen: IdentityScreen},
  Name: {screen: NameScreen},
  Phone: {screen: PhoneScreen},
  Save: {screen: SaveScreen},
  Location: {screen: LocationScreen},
  Location2: {screen: Location2Screen},
  Schedule: {screen: ScheduleScreen},
});

const AgendaContainer = createAppContainer(AgendaNavigator);

export default AgendaContainer;
